import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { Autocomplete } from '@mui/material';
import { getNames, registerLocale } from 'i18n-iso-countries';
import germanCountryCodes from 'i18n-iso-countries/langs/de.json';
import englishCountryCodes from 'i18n-iso-countries/langs/en.json';
import { Control } from 'react-hook-form/dist/types/form';
import { TextField } from '../TextField';

registerLocale(germanCountryCodes);
registerLocale(englishCountryCodes);

interface Props {
  name: string;
  control: Control<any>;
  // TextFieldProps
  label: string;
  helperText?: string;
  error?: boolean;
}

interface Option {
  code: string;
  label: string;
}

export const CountrySelectField = ({ control, name, ...textFieldProps }: Props) => {
  const { t, i18n } = useTranslation();

  const options = React.useMemo(() => getNames(i18n.language), [i18n.language]);

  const codes = React.useMemo(() => Object.keys(options), [options]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ...cProps } }) => (
        <Autocomplete
          {...cProps}
          onChange={(e, data) => onChange(data)}
          disableClearable={true}
          autoHighlight={true}
          options={codes}
          noOptionsText={t('checkout.purchaser_form.no_country_option')}
          getOptionLabel={option => options[option]}
          renderInput={params => (
            <TextField
              {...textFieldProps}
              {...params}
              inputProps={{
                ...params.inputProps,
                autoComplete: 'new-password', //disable autocomplete
              }}
            />
          )}
        />
      )}
    />
  );
};
